import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FcpFooterBarComponent } from './fcp-footer-bar.component';

@NgModule({
    imports: [CommonModule],
    providers: [],
    declarations: [FcpFooterBarComponent],
    exports: [FcpFooterBarComponent]
})
export class FcpFooterBarModule {}
